<template>
  <div class="rj-page-card">
    <div class="rj-page-card__content">
      <span :style="styleColor">
        {{ showMessage() }}
      </span>
    </div>
  </div>
</template>

<script>
import { getNum } from '@/libs/util.js';
import Big from 'big.js';

export default {
  name: 'AbatementReminder',
  data () {
    return {
      message: '',
      styleColor: {
        color: 'red'
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    distributorParticipate: {
      type: Boolean,
      default: true
    },
    integratorParticipate: {
      type: Boolean,
      default: true
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  computed: {
  },
  methods: {
    showMessage () {
      let message = '';
      if (this.form.rebate !== 1) {
        let count = Big(1).minus(getNum(this.form.rebate)).times(100).toString();
        if (this.distributorParticipate === true && this.integratorParticipate === true && this.form.salesType === 1) {
          // if (this.form.contractType === '特价下单') {
          //   message = '特价项目，总代下单，不扣减资金点。';
          // }
          if (this.form.contractType === '非特价下单') {
            message = `非特价项目，总代下单，扣减${count}%资金点。`;
          } else if (this.form.contractType === 'SMB分销下单') {
            message = `SMB分销下单，已扣减${count}%资金点。`;
          } else if (this.form.contractType === '服务商分销下单') {
            message = `服务商分销下单，已扣减${count}%资金点。`;
          }
        } else if (this.distributorParticipate === false && this.integratorParticipate === true && this.form.salesType === 1) {
          if (this.form.contractType === 'SMB分销下单') {
            message = `SMB分销下单，已扣减${count}%资金点。`;
          } else if (this.form.contractType === '服务商分销下单') {
            message = `服务商分销下单，已扣减${count}%资金点。`;
          } else if (this.form.integratorType === '增值白金' || this.form.integratorType === '增值金牌') {
            message = `增值白金/增值金牌从锐捷直接下单，已扣减${count}%现金点。`;
          } else if (this.form.integratorType !== '增值白金' && this.form.integratorType !== '增值金牌') {
            message = `渠道从锐捷直接下单，已扣减${count}%资金点。`;
          }
        }
        if (this.form.contractType === '非特价下单' && this.form.isCloudDesktopMatching === true) {
          if (this.distributorParticipate === true && this.integratorParticipate === true) {
            message = `云课堂产品，非特价渠道项目，渠道从总代下单，扣减${count}%资金点。`;
          } else if (this.distributorParticipate === false && this.integratorParticipate === true) {
            message = `云课堂产品，非特价渠道项目，渠道从锐捷下单，已扣减${count}%资金点。`;
          }
        }
      } else {
        message = `根据${this.form.createTime && this.form.createTime.substr(0, 4)}年新政策${this.form.contractType}不扣除现金点`;
      }
      return message;
    }
  },
  mounted () {
  }
};
</script>
